import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { logout } from 'api/auth/logout';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/login', { replace: true });
  }, [navigate]);

  return null;
};

export default Logout;
